var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2024 Eduardo Robles <edu@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { SimpleForm, TextInput, useEditController, Toolbar, SaveButton, useNotify } from "react-admin";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { AuthContext } from "@/providers/AuthContextProvider";
import { IPermissions } from "@/types/keycloak";
export var SettingsLookAndFeel = function () {
    var _a, _b, _c, _d;
    var tenantId = useTenantStore()[0];
    var _e = useTranslation(), t = _e.t, i18n = _e.i18n;
    var notify = useNotify();
    var authContext = useContext(AuthContext);
    var _f = useEditController({
        resource: "sequent_backend_tenant",
        id: tenantId,
        redirect: false,
        undoable: false,
    }), record = _f.record, save = _f.save, isLoading = _f.isLoading;
    var canEdit = authContext.isAuthorized(true, authContext.tenantId, IPermissions.TENANT_WRITE);
    var _g = useState((_a = record === null || record === void 0 ? void 0 : record.annotations) === null || _a === void 0 ? void 0 : _a.logo_url), logoUrl = _g[0], setLogoUrl = _g[1];
    var _h = useState((_b = record === null || record === void 0 ? void 0 : record.annotations) === null || _b === void 0 ? void 0 : _b.css), cssContent = _h[0], setCssContent = _h[1];
    var _j = useState((_d = (_c = record === null || record === void 0 ? void 0 : record.settings) === null || _c === void 0 ? void 0 : _c.help_links) !== null && _d !== void 0 ? _d : []), helpLinks = _j[0], setHelpLinks = _j[1];
    var _k = useState(false), saveDisabled = _k[0], setSaveDisabled = _k[1];
    useEffect(function () {
        if (saveDisabled) {
            setSaveDisabled(false);
        }
    }, [logoUrl, cssContent, helpLinks]);
    var handleHelpLinksChange = function (event) {
        try {
            var parsedHelpLinks = !event.target.value || event.target.value.trim().length === 0
                ? []
                : JSON.parse(event.target.value);
            if (Array.isArray(parsedHelpLinks)) {
                setHelpLinks(parsedHelpLinks);
            }
            else {
                notify(t("lookAndFeelScreen.errors.invalidHelpLinks"), { type: "error" });
            }
        }
        catch (error) {
            notify(t("lookAndFeelScreen.errors.invalidHelpLinks"), { type: "error" });
        }
    };
    var onSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var logoUrlToSave, cssContentToSave;
        var _a, _b;
        return __generator(this, function (_c) {
            logoUrlToSave = logoUrl === "" ? null : logoUrl;
            cssContentToSave = cssContent === "" ? null : cssContent;
            console.log("onSave logoUrl: ", logoUrlToSave);
            console.log("onSave cssContent: ", cssContentToSave);
            console.log("onSave helpLinks: ", helpLinks);
            save({
                annotations: __assign(__assign({}, ((_a = record === null || record === void 0 ? void 0 : record.annotations) !== null && _a !== void 0 ? _a : {})), { logo_url: logoUrlToSave, css: cssContentToSave }),
                settings: __assign(__assign({}, ((_b = record === null || record === void 0 ? void 0 : record.settings) !== null && _b !== void 0 ? _b : {})), { help_links: helpLinks }),
            });
            setSaveDisabled(true);
            return [2 /*return*/];
        });
    }); };
    if (isLoading)
        return null;
    return (_jsxs(SimpleForm, __assign({ toolbar: _jsx(Toolbar, { children: canEdit ? (_jsx(SaveButton, { onClick: function () {
                    onSave();
                }, type: "button", disabled: saveDisabled })) : null }) }, { children: [_jsx(TextInput, { resettable: true, source: "annotations.logo_url", defaultValue: logoUrl, label: t("lookAndFeelScreen.common.logoUrl"), onBlur: function (event) { return setLogoUrl(event.target.value); } }), _jsx(TextInput, { resettable: true, multiline: true, source: "annotations.css", defaultValue: cssContent, label: t("lookAndFeelScreen.common.css"), onBlur: function (event) { return setCssContent(event.target.value); } }), _jsx(TextInput, { resettable: true, multiline: true, source: "settings.help_links", defaultValue: JSON.stringify(helpLinks, null, 2), label: t("lookAndFeelScreen.common.helpLinks"), onBlur: handleHelpLinksChange })] })));
};
